import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i3.15
import React from 'react';
import IconWrap from '../../IconWrap';
const Refresh = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M4 11a1 1 0 011 1v.5a6.5 6.5 0 006.267 6.496L11.5 19h1a6.481 6.481 0 004.69-2H16a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-1.993.117L19 20l.001-2.024A8.482 8.482 0 0112.5 21h-1A8.5 8.5 0 013 12.5V12a1 1 0 011-1zm8.5-8a8.5 8.5 0 018.5 8.5v.5a1 1 0 01-2 0v-.5a6.5 6.5 0 00-6.267-6.496L12.5 5h-1c-1.749 0-3.336.69-4.505 1.814L6.81 7H8a1 1 0 110 2H4a1 1 0 01-1-1V4a1 1 0 011.993-.117L5 4l-.001 2.024A8.482 8.482 0 0111.5 3h1z"
    })));
Refresh.displayName = 'Refresh';
export default Refresh;
